SupportMerchantLocationInfoTemplate = require '../../../../merchant_location_info.html.mustache'
EmailFormUSLocationListView = require "./location_list_view"
EmailFormUSLocationElementView = require "./location_element_view"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSMerchantLocationInfoView extends Backbone.View
  tagName:'li'
  className: 'requestedFields'

  events:
    'click #showAllLocations' : 'showAllLocations'
    'keyup #businessLocation' : 'enableDisableSubmitButton'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportMerchantLocationInfoTemplate
    @model = @options.model
    @isInputCompulsory = @model.required
    if Groupon.Support.currentOrder?.dealOption?.redemptionLocations?.length > 0
      for location, i in Groupon.Support.currentOrder.dealOption.redemptionLocations
        location.isSelected = false
        location.locationId = i

    @numberOfRedemptionLocations = @model.numberOfRedemptionLocations
    @collectFromAvailableLocations = @numberOfRedemptionLocations > 0

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    @onLocationSelectionDone()

  toHash: ->
    collectFromAvailableLocations: @collectFromAvailableLocations
    numOfRedemptionLocations: @numberOfRedemptionLocations
    showAll: @numberOfRedemptionLocations > 3
    currentUserAndOrderCheck: if currentUser? and Groupon.Support.currentOrder? then true else false

  showAllLocations: ->
    locationListView = new EmailFormUSLocationListView({'cb':@onLocationSelectionDone})

  enableDisableSubmitButton: ->
    @options.validateEmailForm.call()

  onLocationSelectionDone: ->
    if @numberOfRedemptionLocations > 1
      locationsToShowinMainPage = []

      selectedLocations = @getSelectedLocations()

      if selectedLocations.length == 0
        locationsToShowinMainPage = _.first(Groupon.Support.currentOrder.dealOption.redemptionLocations, 5)
      else
        locationsToShowinMainPage = selectedLocations

      $('#locations',@$el).empty()
      for location in locationsToShowinMainPage
        locationView = new EmailFormUSLocationElementView({'location':location, 'cb':@enableDisableSubmitButton})
        locationView.render()
        $('#locations',@$el).append(locationView.el)

      @enableDisableSubmitButton()

  getSelectedLocations: ->
    _.filter(Groupon.Support.currentOrder.dealOption.redemptionLocations, (location) ->
      location.isSelected == true
    )

  getBusinessLocationElement: ->
    @$el.find('#businessLocation')

  populateInput: (data) ->
    data.businessLocation = @getBusinessLocationElement()?.val()?.trim()
    data.merchantInfoView = true

  isInputGiven: ->
    if @numberOfRedemptionLocations > 0
      @numberOfRedemptionLocations == 1 || @getSelectedLocations().length > 0
    else
      @getBusinessLocationElement()?.val()?.trim().length > 0

  isInputValid: ->
    true

module.exports = EmailFormUSMerchantLocationInfoView
